import { IGroupStatus } from '@routes/private/Editor/types';

export const isGroupOpen = (groupId: string, groupsStatus: IGroupStatus[]):boolean => {
    return groupsStatus.filter((group) => group.groupId==groupId).length?groupsStatus.filter((group) => group.groupId==groupId)[0].isOpen:false;
}
